/**
 * Profile Summary LLM Prompt — Sprint 17g-1
 *
 * Builds the prompt used by regenerateSummary() to create
 * a compact ProfileSummary from all profile layers.
 */
export function buildProfileSummaryPrompt(identity, interests, behaviors, _context, personality) {
    return `You are summarizing a user profile for a personal AI assistant.
Write a concise narrative (max 200 words) describing who this person is and what they care about.
Also extract up to 10 preference directives (condition → preference pairs).

INPUT DATA:
${identity ? `Demographics: age=${identity.ageRange ?? 'unknown'}, gender=${identity.gender ?? 'unknown'}, household=${identity.household?.type ?? 'unknown'}, spending=${identity.economic?.spendingTier ?? 'unknown'}` : 'No demographic data yet.'}

${interests ? `Interest clusters (${interests.clusters.length}):
${interests.clusters.map(c => `- ${c.label}: ${c.topics.map(t => t.name).join(', ')} [${c.lifecycle}, ${c.trend}]`).join('\n')}
Anti-interests: ${interests.antiInterests.map(a => a.topic).join(', ') || 'none'}` : 'No interests yet.'}

${behaviors ? `Behavioral patterns:
- Total missions: ${behaviors.missionPatterns.totalPresented} shown, ${behaviors.missionPatterns.totalAccepted} accepted, ${behaviors.missionPatterns.totalDismissed} dismissed
- Acceptance patterns: ${behaviors.missionPatterns.acceptancePatterns.join('; ') || 'none detected'}
- Dismissal patterns: ${behaviors.missionPatterns.dismissalPatterns.join('; ') || 'none detected'}` : 'No behavioral data yet.'}

${personality && personality.ocean.confidence > 0.5 ? `Personality (OCEAN): O=${personality.ocean.openness}, C=${personality.ocean.conscientiousness}, E=${personality.ocean.extraversion}, A=${personality.ocean.agreeableness}, N=${personality.ocean.neuroticism}` : ''}

Return ONLY JSON:
{
  "narrative": "200-word natural language summary of who this person is",
  "directives": [
    { "condition": "when recommending restaurants", "preference": "prefers outdoor seating", "confidence": 0.8, "source": "inferred" }
  ],
  "ikigaiWeights": { "passion": 0.0-1.0, "mission": 0.0-1.0, "profession": 0.0-1.0, "vocation": 0.0-1.0 }
}`;
}
//# sourceMappingURL=profile-prompts.js.map